// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconMapMarker = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M14 10a2 2 0 11-4 0 2 2 0 014 0" />,
    <path
      fillRule="evenodd"
      d="M12.914 22h-1.828q-.693-.691-1.346-1.418a40 40 0 01-2.293-2.798c-.833-1.122-1.684-2.41-2.33-3.726C4.48 12.756 4 11.345 4 10c0-5.144 4.044-8 8-8s8 2.856 8 8c0 1.345-.48 2.756-1.118 4.058-.646 1.316-1.496 2.604-2.33 3.726a40 40 0 01-2.292 2.798A37 37 0 0112.914 22M6 10c0-3.856 2.956-6 6-6s6 2.144 6 6c0 .905-.333 1.994-.913 3.177-.573 1.168-1.348 2.349-2.14 3.414A38 38 0 0112.077 20h-.153a38 38 0 01-2.871-3.409c-.792-1.065-1.566-2.246-2.14-3.414C6.333 11.994 6 10.905 6 10"
    />
  );
export default SvgIconMapMarker;
